var FeaturedContentVideo = (function () {
    var config = {
        modalVideoSelector: ".modal-video",
        bodyVideoClass: "has-videocontainer",
        modalEventShown: "shown.bs.modal",
        modalEventHidden: "hidden.bs.modal",
        youTubeVideoSelector: null,
        html5VideoSelector: null,
        resizeTimeout: null,
    };
    
    function FeaturedContentVideo() {
        //method intentionally left empty
    }
    
    FeaturedContentVideo.prototype.init = function () {
        var self = this;
    
        // Add class to body if .videocontainer exists
        if ($(config.modalVideoSelector).length > 0) {
            $("body").addClass(config.bodyVideoClass);
        }
    
        self.bindEvents();
        self.autoplayVideosOnLoad();
    };
    
    FeaturedContentVideo.prototype.bindEvents = function () {
        var self = this;
    
        // Bind events for modals
        $(config.modalVideoSelector).on(config.modalEventShown, function (e) {
            self.onModalShown(e);
        });
    
        $(config.modalVideoSelector).on(config.modalEventHidden, function (e) {
            self.onModalHidden(e);
        });
    
        // Bind events for window resize
        $(window).on("resize", function () {
            //clear timeout
            clearTimeout(config.resizeTimeout);
    
            //set timeout
            config.resizeTimeout = setTimeout(function () {
                self.setYouTubeWidthAndHeight();
                self.setHtml5VideoWidthAndHeight();
            }, 400);
        });
    };
    
    var ytApiLoaded = false;
    function loadYouTubeAPI() {
    if (ytApiLoaded) return;
    ytApiLoaded = true;
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    
    // Append params like enablejsapi=1
    function appendIframeParams(ytIframe) {
    if (!ytIframe) return;
    
    const iframe = $(ytIframe);
    let src = iframe.attr('src');
    
    const params = [
        { param: 'enablejsapi', value: '1' },
        { param: 'rel', value: '0' },
        { param: 'modestbranding', value: '1' }
    ];
    
    for (let i = 0; i < params.length; i++) {
        if (!src.includes(`${params[i].param}=`)) {
        const queryParam = {};
        queryParam[params[i].param] = params[i].value;
        src = $.fn.urlUtil.mergeQuery(src, queryParam);
        }
    }
    
    iframe.attr('src', src);
    }
    
    //  For Brightcove video
    // Check if videojs is loaded     
    function waitForBrightcove(callback) {
        if (typeof videojs !== "undefined") {
            callback();
        } else {
            setTimeout(function () {
                waitForBrightcove(callback);
            }, 500);
        }
    }
    const ytPlayers = new Map();
    FeaturedContentVideo.prototype.onModalShown = function (e) {
        var self = this;
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");
        const modalId = modal.attr("id");
        console.log("Modal ID:", modalId);
        const $ctaBtn = $(`[data-bs-target="#${modalId}"]`).first();
        console.log("CTA Button:", $ctaBtn);
        const parentComponent = $ctaBtn.closest('.featured-content');
        if (video.length > 0) {
            video[0].play();
            self.html5VideoSelector = video;
            self.setHtml5VideoWidthAndHeight();
        } else if (iframe.length > 0) {
            self.youTubeVideoSelector = iframe;
            self.setYouTubeWidthAndHeight();
        }
        if ($ctaBtn.length === 0) {
            console.warn("No CTA found for modal:", modalId);
            return;
        }
        if (parentComponent.length === 0) {
            console.warn("No CTA found for modal:", modalId);
            return;
        }
        if (parentComponent.length > 0) {
                    
            const ytIframe = modal.find('iframe[src*="youtube"]')[0];
        
            if (ytIframe) {
                appendIframeParams(ytIframe);
                const iframeId = ytIframe.id || `yt-iframe-${Date.now()}`;
                ytIframe.id = iframeId; // ensure it has an ID
        
                function createYTPlayerWhenReady() {
                    setTimeout(() => {
                        const player = new YT.Player(ytIframe, {
                            events: {
                                'onStateChange': function (event) {
                                    if (event.data === YT.PlayerState.PLAYING) {
                                        console.log("YouTube video play detected.");
                                        trackAnalytics($(ytIframe), player);
                                    }
                                }
                            }
                        });
                
                        ytPlayers.set(iframeId, player);
                    }, 1000); // 1000ms delay to ensure iframe is settled
                }
        
                // If API already loaded
                if (window.YT && window.YT.Player) {
                createYTPlayerWhenReady();
                } else {
                // If API not ready, queue it
                window.onYouTubeIframeAPIReady = function () {
                    createYTPlayerWhenReady();
                };
                }
        
                loadYouTubeAPI(); // Load the script only once
            }
             /* For Youtube video */
             /* For Brightcove video */
            waitForBrightcove(initVideoEvents);
            function initVideoEvents() {
                modal.find(".video-js").each(function () {
                    console.log("it is inside video");
                    var videoElem = this;
                    if (!$(videoElem).data("initialized")) {
                        var bcPlayer = videojs(videoElem);
                        var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();
        
                        $(videoElem).data("initialized", true);
        
                        bcPlayer.ready(function () {
                            //  console.log("Brightcove Video Duration Found:", videoDurations[videoId]);
                            bindPlayerEvents(bcPlayer, videoId);
                        });
                    }
                });
            }
    
            function bindPlayerEvents(player, videoId) {
                console.log("bindPlayerEvents");
            
                // Add small delay to ensure player is truly ready
                player.ready(function () {
                    setTimeout(() => {
                        let hasTracked = false;
            
                        player.on("firstplay", function () {
                           // console.log("Firstplay triggered");
                            if (!hasTracked) {
                                hasTracked = true;
                                trackAnalytics(player, videoId);
                            }
                        });
            
                        player.on("playing", function () {
                          //  console.log("Playing triggered");
                            if (!hasTracked) {
                                hasTracked = true;
                                trackAnalytics(player, videoId);
                            }
                        });
            
                        player.on("timeupdate", function () {
                            if (!hasTracked && player.currentTime() > 0) {
                                hasTracked = true;
                                console.log("timeupdate triggered at", player.currentTime());
                                trackAnalytics(player, videoId);
                            }
                        });
                    }, 200);
                });
            }
            
         /* For Brightcove video */
            function trackAnalytics() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    componentInteraction: "componentInteraction",
                    componentType: "featuredContent",
                    interactionType: "videoPlay",
                    elementClicked: "video",
                    contentTitle: contentTitle(),
                    destinationURL: "",
                    deviceType: getDeviceType()
                });
                console.log('Tracked YouTube videoPlay event');
            }
        }
    };
    
    function contentTitle() {
        const header = $(".featured-content__heading").find("h1, h2, h3, h4, h5, h6").first();
        return header.text().trim();
    }
    function getDeviceType() {
        const userAgent = navigator.userAgent;
        const width = window.innerWidth;
    
        if(/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
            return "tablet";
        } else if (/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(userAgent)) {
            return "mobile";
        } else {
            return "desktop";
        }
    
    }
    
    FeaturedContentVideo.prototype.setHtml5VideoWidthAndHeight = function () {
        var self = this;
        if (!self.html5VideoSelector) {
            return;
        }
    
        self.setVideoDimensions(self.html5VideoSelector);
    };
    
    FeaturedContentVideo.prototype.setYouTubeWidthAndHeight = function () {
        var self = this;
        if (!self.youTubeVideoSelector) {
            return;
        }
    
        self.setVideoDimensions(self.youTubeVideoSelector);
    };
    
    FeaturedContentVideo.prototype.setVideoDimensions = function (element) {
        var windowWidth = $(window).width() - 40;
        var windowHeight = $(window).height() - 110;
        var aspectRatio = 16 / 9;
        var newWidth = windowWidth;
        var newHeight = windowWidth / aspectRatio;
    
        if (newHeight > windowHeight) {
            newHeight = windowHeight;
            newWidth = windowHeight * aspectRatio;
        }
    
        element.css({
            width: newWidth,
            height: newHeight
        });
    };
    
    FeaturedContentVideo.prototype.onModalHidden = function (e) {
        this.stopVideoAndIframe(e);
    };
    
    FeaturedContentVideo.prototype.stopVideoAndIframe = function (e) {
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");
    
        if (video.length > 0) {
            video[0].pause();
            video[0].currentTime = 0;
        } else if (iframe.length > 0) {
            var youtubeSrc = $(iframe).attr("src");
            $(iframe).attr("src", "");
            $(iframe).attr("src", youtubeSrc);
            self.youTubeVideoSelector = null;
        }
    };
    
    FeaturedContentVideo.prototype.autoplayVideosOnLoad = function () {
        // Autoplay videos with autoplay attribute on page load
        $("video[autoplay]").each(function () {
            this.play();
        });
    };
    
    return FeaturedContentVideo;
    })();
    
    // Initialize the class when the document is ready
    $(document).ready(function () {
        if ($(".modal-video").length > 0) {
            new FeaturedContentVideo().init();
        }
    
        var allFeaturedContentsOnThePage = document.querySelectorAll('.featured-content');
        playPauseBackgroundVideo(allFeaturedContentsOnThePage);
    });
    
    
    function playPauseBackgroundVideo(allFeaturedContentsOnThePage) {
        allFeaturedContentsOnThePage.forEach(function (item) {
                var itemPlay = item.querySelector('.featured-content__playBtn');
                var video = item.querySelector('.featured-content__player');
    
                if(itemPlay) {
                    itemPlay.addEventListener("click", function () {
                        if (hasClass(itemPlay, 'icon-play-btn')) {
                            removeClass(itemPlay, 'icon-play-btn');
                            addClass(itemPlay, 'icon-pause-btn');
                            video.play();
                            } else {
                            removeClass(itemPlay, 'icon-pause-btn');
                            addClass(itemPlay, 'icon-play-btn');
                            video.pause();
                        }
                    })
                }
            }
        )
    }
    
    /*Analytics*/
    analytics.eventConfig.push({
        "target": ".featured-content", //featured content
        "events": [
            {
                "eventTarget": ".featured-content__text-box .cta-button a.button-primary", 
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button a.button-secondary", 
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button a.button-secondary-white", 
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button-popup-modal a.button-primary",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button-popup-modal a.button-secondary",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button-popup-modal a.button-secondary-white",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "button", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button a.button-tertiary",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "link", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button a.button-tertiary--white",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "link", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button-popup-modal a.button-tertiary",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "link", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__text-box .cta-button-popup-modal a.button-tertiary--white",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "link", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__copy a",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "click", // possible values: click, videoPlay 
                    "elementClicked": "link", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__playBtn",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "videoPlay", // possible values: click, videoPlay 
                    "elementClicked": "video", // possible values: link, button, video
                }
            },
            {
                "eventTarget": ".featured-content__big-play-icon",
                "eventType": "click",
                "tags": {
                   "event": "componentInteraction",
                    "componentType": "featuredContent",
                    "interactionType": "videoPlay", // possible values: click, videoPlay 
                    "elementClicked": "video", // possible values: link, button, video
                }
            },
        ]
    });